// extracted by mini-css-extract-plugin
export default {"container":"Z2hKX","titleRow":"TUrwp","title":"oTQRo","viewItems":"_3C9Wd","spreadRow":"_1inCl","total":"_9qz7"};